module.exports = __webpack_public_path__ + "img/4-1-1-2-preview-hoteloffer-conrad-c.b729baa8.jpg";